<form class="flex flex-col gap-2" [formGroup]="form">
  <div class="mb-4 flex flex-col gap-1">
    <div class="flex flex-row flex-wrap gap-4">
      <mat-form-field class="flex grow" subscriptSizing="dynamic">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="firstName" required />
      </mat-form-field>
      <mat-form-field class="flex grow" subscriptSizing="dynamic">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="lastName" required />
      </mat-form-field>
    </div>
    <div class="px-4 text-[10px] opacity-50">
      Preferred name example: Leonardo (Leo). (Leo) will be removed from patient
      correspondence.
    </div>
  </div>

  <mat-form-field class="flex-1">
    <mat-label>Gender</mat-label>
    <mat-select formControlName="gender" required>
      <mat-option
        *ngFor="let gender of genders; trackBy: trackByGender"
        [value]="gender"
      >
        {{ gender | splitCamel | titlecase }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <pt-iso-date-selector
    class="flex-1"
    placeholder="Date of birth"
    formControlName="dateOfBirth"
    [required]="'dateOfBirth' | map: isRequired$ : this | async"
    [max]="today"
    (focusout)="onDobBlur()"
  />

  <pr-address-input formControlName="address" />

  <mat-form-field class="flex-1">
    <mat-label>Email</mat-label>
    <input
      matInput
      type="email"
      formControlName="email"
      [required]="'email' | map: isRequired$ : this | async"
      [errorStateMatcher]="errorStateMatcher"
    />
    @if (form.controls.email.hasError('email')) {
      <mat-error>Please enter a valid email address</mat-error>
    }
  </mat-form-field>

  <div formArrayName="contactNumbers" fxLayout="column">
    <pr-contact-number-input
      *ngFor="
        let control of contactNumberControls.controls;
        trackBy: trackByIndex;
        index as index;
        first as isFirst
      "
      [form]="control"
      [isFirst]="isFirst"
      [index]="index"
      [required]="'contactNumbers' | map: isRequired$ : this | async"
    >
      <div class="flex flex-row content-center">
        <button
          mat-icon-button
          (click)="contactNumberControls.addControl(index)"
        >
          <mat-icon>add</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="contactNumberControls.removeControl(index)"
        >
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    </pr-contact-number-input>
  </div>

  <ng-container *prIsRegion="[Region.NewZealand]">
    @if (showSchoolField$ | async) {
      <mat-form-field class="flex-1">
        <mat-label>School Attended</mat-label>
        <input
          placeholder="Search schools..."
          formControlName="school"
          matInput
          [matAutocomplete]="schoolAuto"
        />
        <mat-hint
          >School Attended is used for Ministry of Health (MOH)
          patients.</mat-hint
        >
        <mat-autocomplete
          #schoolAuto="matAutocomplete"
          [displayWith]="schoolDisplayFn"
        >
          @for (
            school of schoolSearch.results$ | async;
            track school.schoolNumber
          ) {
            <mat-option [value]="school">{{ school.schoolName }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
  </ng-container>

  <mat-form-field
    *ngIf="referralSources$ | async as referralSources"
    class="flex-1"
  >
    <mat-label>Referrer</mat-label>
    <mat-select
      formControlName="referrer"
      [required]="'referrer' | map: isRequired$ : this | async"
    >
      <mat-option
        *ngFor="let source of referralSources; trackBy: trackByReferralSource"
        [value]="source | map: toReferralSource : this"
      >
        {{ source.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  @if (hasHealthCards$ | async) {
    <h3 class="!m-0 !font-bold">Health Fund Card Details</h3>

    @if (healthCardEnabled$('healthFund') | async) {
      <mat-checkbox formControlName="showHealthFundCard">
        Health Fund Card
      </mat-checkbox>
      <pr-patient-details-health-fund-form
        *ngIf="form.controls.showHealthFundCard.value"
        [form]="form.controls.healthFundCard"
      />
    }

    @if (healthCardEnabled$('medicare') | async) {
      <mat-checkbox formControlName="showMedicareCard">
        Medicare Card
      </mat-checkbox>
      <pr-patient-details-medicare-form
        *ngIf="form.controls.showMedicareCard.value"
        [form]="form.controls.medicareCard"
      />
    }

    @if (healthCardEnabled$('dva') | async) {
      <mat-checkbox formControlName="showDVACard">DVA Card</mat-checkbox>
      <pr-patient-details-dva-form
        *ngIf="form.controls.showDVACard.value"
        [form]="form.controls.dvaCard"
      />
    }

    @if (healthCardEnabled$('nhi') | async) {
      <pr-national-health-index-number-form
        (nationalHealthIndexNumberChange)="
          form.controls.nationalHealthIndexNumber.setValue($event)
        "
      />
    }
  }
</form>
